import { useState } from 'react';
import { Button, Menu, MenuItem, ListItemText } from '@mui/material';
import { ExpandMore, Layers, Check } from '@mui/icons-material';
import { useVertical } from '../../hooks/useVertical';

/**
 * Header business-vertical switcher. Pinning a vertical sends x-vertical-id on
 * every request (narrowing row-level scope) and filters the menu. Renders only
 * when the user can access more than one vertical.
 */
export function VerticalSwitcher() {
  const { verticals, activeVertical, setActiveVertical } = useVertical();
  const [anchor, setAnchor] = useState<HTMLElement | null>(null);

  if (verticals.length <= 1) return null;

  const choose = (id: number | null) => {
    setActiveVertical(id);
    setAnchor(null);
  };

  return (
    <>
      <Button
        size="small"
        color="inherit"
        startIcon={<Layers fontSize="small" />}
        endIcon={<ExpandMore fontSize="small" />}
        onClick={(e) => setAnchor(e.currentTarget)}
        sx={{ textTransform: 'none', fontWeight: 600, mr: 0.5, display: { xs: 'none', sm: 'inline-flex' } }}
      >
        {activeVertical?.name ?? 'All Verticals'}
      </Button>
      <Menu anchorEl={anchor} open={Boolean(anchor)} onClose={() => setAnchor(null)}>
        <MenuItem selected={activeVertical === null} onClick={() => choose(null)}>
          <ListItemText>All Verticals</ListItemText>
          {activeVertical === null && <Check fontSize="small" />}
        </MenuItem>
        {verticals.map((v) => (
          <MenuItem key={v.id} selected={activeVertical?.id === v.id} onClick={() => choose(v.id)}>
            <ListItemText>{v.name}</ListItemText>
            {activeVertical?.id === v.id && <Check fontSize="small" />}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
}
